import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campEuReorder: FaireAdCampaignEntity = {
  token: "camp_eu_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_eu_brand",
  segment: "REORDER_MARKETPLACE",
  status: "STOPPED",
  monthlyBudgetDollars: 100,
  startedRunningAt: "2026-06-09",
  stoppedRunningAt: "2026-10-01",
  segmentMetrics: {
    numReorderConversions: 10,
    salesDollars: 2368,
    totalAdsSpendDollars: 123,
    returnOnAdSpend: 19.23,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-10-12T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
